'use strict';

var React = require('react');
var Border = require('../common/Border');
var styleHelper = require('../../helper/styleHelper');

/*
 * 遮罩组件
 */
var ModalScreen = React.createClass({

  render: function () {
    var style = {};
    styleHelper.builderBackgroundStyle(this.props, style);
    return (<div className="component-SimpleCom" style={style}></div>);
  }

});

module.exports = ModalScreen;


// WEBPACK FOOTER //
// ./src/views/Components/ModalScreen.jsx